import { BOOKS } from "@/lib/catalog";

const W = 1080;
const H = 1350;
const GOLD = "#C9A227";

function loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src.startsWith("http") ? `${src}?finishedcard=1` : src;
  });
}

function fitText(ctx, text, font, size, maxW) {
  let s = size;
  do {
    ctx.font = font.replace("{s}", s);
    s -= 2;
  } while (ctx.measureText(text).width > maxW && s > 30);
}

export async function renderFinishedCard({ productId, name, finishedAt }) {
  const meta = BOOKS.find((b) => b.id === productId);
  await Promise.all(
    ["500 24px 'IBM Plex Mono'", "600 90px 'Cormorant Garamond'", "italic 600 90px 'Cormorant Garamond'", "400 28px Manrope"].map((f) =>
      document.fonts.load(f).catch(() => {})
    )
  );
  const cover = meta ? await loadImage(meta.cover) : null;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#0B0C10";
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W / 2, 470, 40, W / 2, 470, 650);
  glow.addColorStop(0, "rgba(201,162,39,0.25)");
  glow.addColorStop(1, "rgba(201,162,39,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 3;
  ctx.strokeRect(36, 36, W - 72, H - 72);
  ctx.strokeStyle = "rgba(201,162,39,0.4)";
  ctx.lineWidth = 1;
  ctx.strokeRect(52, 52, W - 104, H - 104);

  ctx.textAlign = "center";
  ctx.fillStyle = GOLD;
  ctx.font = "500 24px 'IBM Plex Mono'";
  ctx.fillText("T H E   L E C K I E   N O V E L S", W / 2, 130);

  if (cover) {
    const h = 560;
    const w = h * (cover.width / cover.height);
    ctx.save();
    ctx.shadowColor = "rgba(0,0,0,0.8)";
    ctx.shadowBlur = 50;
    ctx.shadowOffsetY = 24;
    ctx.drawImage(cover, (W - w) / 2, 180, w, h);
    ctx.restore();
    ctx.strokeStyle = "rgba(255,255,255,0.18)";
    ctx.strokeRect((W - w) / 2, 180, w, h);
  }

  ctx.fillStyle = "#F5F2EA";
  ctx.font = "600 90px 'Cormorant Garamond'";
  ctx.fillText("I finished", W / 2, 870);
  ctx.fillStyle = GOLD;
  fitText(ctx, meta?.fullTitle || "the book", "italic 600 {s}px 'Cormorant Garamond'", 90, W - 180);
  ctx.fillText(meta?.fullTitle || "the book", W / 2, 970);
  ctx.fillStyle = "#A9A59B";
  ctx.font = "400 28px Manrope";
  ctx.fillText("by Michael Leckie", W / 2, 1030);

  const when = new Date(finishedAt || Date.now()).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
  ctx.fillStyle = "#F5F2EA";
  ctx.font = "500 26px 'IBM Plex Mono'";
  ctx.fillText(`${name ? `${name.toUpperCase()} · ` : ""}${when.toUpperCase()}`, W / 2, 1130);
  ctx.fillStyle = GOLD;
  ctx.font = "400 26px Manrope";
  ctx.fillText(`Read & listen at ${window.location.host}/reader`, W / 2, 1230);
  return canvas.toDataURL("image/png");
}

export async function renderCompletionistCard({ name, finishedAt }) {
  await document.fonts.load("italic 600 96px 'Cormorant Garamond'").catch(() => {});
  const covers = await Promise.all(BOOKS.slice(0, 4).map((b) => loadImage(b.cover)));
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#0B0C10";
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W / 2, 520, 40, W / 2, 520, 700);
  glow.addColorStop(0, "rgba(201,162,39,0.32)");
  glow.addColorStop(1, "rgba(201,162,39,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);
  [[3, 36], [1, 52], [1, 66]].forEach(([lw, inset], i) => {
    ctx.strokeStyle = i === 0 ? GOLD : "rgba(201,162,39,0.45)";
    ctx.lineWidth = lw;
    ctx.strokeRect(inset, inset, W - inset * 2, H - inset * 2);
  });
  ctx.textAlign = "center";
  ctx.fillStyle = GOLD;
  ctx.font = "500 24px 'IBM Plex Mono'";
  ctx.fillText("T H E   L E C K I E   N O V E L S", W / 2, 140);

  covers.forEach((img, i) => {
    if (!img) return;
    const w = 250;
    const h = w * (img.height / img.width);
    ctx.save();
    ctx.translate(W / 2 + (i - 1.5) * 170, 470 + Math.abs(i - 1.5) * 18);
    ctx.rotate(((i - 1.5) * 8 * Math.PI) / 180);
    ctx.shadowColor = "rgba(0,0,0,0.8)";
    ctx.shadowBlur = 40;
    ctx.shadowOffsetY = 20;
    ctx.drawImage(img, -w / 2, -h / 2, w, h);
    ctx.restore();
  });

  ctx.fillStyle = "#F5F2EA";
  ctx.font = "600 64px 'Cormorant Garamond'";
  ctx.fillText("Leckie", W / 2, 840);
  ctx.fillStyle = GOLD;
  ctx.font = "italic 600 104px 'Cormorant Garamond'";
  ctx.fillText("Completionist", W / 2, 950);
  ctx.fillStyle = "#A9A59B";
  ctx.font = "400 28px Manrope";
  ctx.fillText("I've read all four Michael Leckie novels", W / 2, 1020);
  const when = new Date(finishedAt || Date.now()).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
  ctx.fillStyle = "#F5F2EA";
  ctx.font = "500 26px 'IBM Plex Mono'";
  ctx.fillText(`${name ? `${name.toUpperCase()} · ` : ""}${when.toUpperCase()}`, W / 2, 1120);
  ctx.fillStyle = GOLD;
  ctx.font = "400 26px Manrope";
  ctx.fillText(`Read & listen at ${window.location.host}/reader`, W / 2, 1230);
  return canvas.toDataURL("image/png");
}
